export const addresses = {
  pnouns: "0x2e5C0BD35995ea7e8903C55ba66f28270310498f",
};
